exports.f = Object.getOwnPropertySymbols;